import { type FC } from 'react';
import {
  useDisclosure
} from '@chakra-ui/react';
import {
  UiHStack,
  UiText,
  UiDrawer,
  UiDrawerOverlay,
  UiDrawerContent,
  UiDrawerBody,
  UiDrawerCloseButton,
  UiStack,
  uiStyles,
  UiImage,
  UiIconInfo,
} from '@/lib/ui';
// import EventInfoList from '@/registration/component/Event/InfoList';
import EventInfoCard from '@/registration/component/Event/InfoCard';
import { useRegisterRoute } from '@/registration/hook/useRegisterRoute';
import { useEventQuery } from '@/registration/hook/useEventQuery';

export interface EventInfoProps {
}

const EventInfo: FC<EventInfoProps> = () => {
  const { isOpen, onToggle } = useDisclosure();
  const { eventId } = useRegisterRoute();
  const { data: event } = useEventQuery(eventId);

  return (
    <>
      <UiHStack
        alignItems={'center'}
        justifyContent={'space-between'}
        px={{base: 6, lg: 12}}
        py={{base: 6, lg: 6}}
        onClick={onToggle}
        spacing={4}
        borderTopRadius={uiStyles.borderRadius}
        borderBottomRadius={uiStyles.borderRadius}
        bgColor={'#fff'}
        // bgColor={'gray.100'}
      >
        <UiHStack justifyContent={'flex-left'} alignItems={'center'} spacing={4}>
          {!!event?.menuLogo && (
            <UiStack display={{ base: 'none', lg: 'flex' }}>
              <UiImage
                src={event?.menuLogo}
                minH={'40px'}
                maxH={'40px'}
                minW={'40px'}
                // borderRadius={uiStyles.borderRadius}
              />
            </UiStack>
          )}
          <UiStack spacing={0}>
            <UiText variant={'body1'} fontWeight={600}>{event?.name}</UiText>
          </UiStack>
        </UiHStack>
        <UiHStack
          // px={{ base: 4, lg: 8 }}
          // py={4}
          justifyContent={'flex-end'}
          alignItems={'center'}
          {...uiStyles.hover}
          // spacing={4}
        >
          {/*<UiText variant={'title'} color={'primary.500'} display={{base: 'none', lg: 'flex'}}>About</UiText>*/}
          {/*<UiIconCaretRight color={'primary.500'} size={'2xl'} weight={'bold'} />*/}
          <UiIconInfo color={'primary.500'} size={'2xl'} weight={'bold'}/>
          {/*<UiStack display={{base: 'none', lg: 'flex'}}>*/}
          {/*  <UiText variant={'title'} color={'primary.500'}>Event details</UiText>*/}
          {/*</UiStack>*/}
        </UiHStack>
      </UiHStack>
      <UiDrawer placement={'right'} size={'lg'} isOpen={isOpen} onClose={onToggle}>
        <UiDrawerOverlay />
        <UiDrawerContent bgColor={'gray.50'}>
          <UiDrawerCloseButton size={'lg'} fontWeight={'bold'} color={'primary.500'} />
          <UiDrawerBody px={0} pb={16} alignItems={'stretch'}>
            <UiStack
              pt={16}
              pb={8}
              flexGrow={1}
            >
              <UiHStack flexGrow={1} justifyContent={'space-around'} alignItems={'flex-start'}>
                <UiStack
                  // minW={320}
                  flexGrow={1}
                  // py={{base: 8, md: 8}}
                >
                  {event && (
                    <EventInfoCard event={event} />
                  )}
                </UiStack>
              </UiHStack>
            </UiStack>
          </UiDrawerBody>
        </UiDrawerContent>
      </UiDrawer>
    </>
  );
};

export default EventInfo;
